import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"content_title"}},[_c(VCard,{staticClass:"pt-4 pl-0 pb-2",attrs:{"width":_vm.width || '100%',"color":"transparent","flat":""}},[_c(VRow,{attrs:{"justify":"space-between","align":"center","no-gutters":""}},[_c(VCol,{staticClass:"font-weight-bold app-text--highlighted text-h5"},[_vm._v(" "+_vm._s(_vm.translate(_vm.title))+" ")]),_vm._t("buttons")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }